<script>
import paperBody from "./paperBody.vue";
export default {
  name: "paperViewDialog",
  components: { paperBody },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    score: {
      type: [String, Number],
      default: "",
    },
    questionList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    visible(val) {
      this.show = val;
    },
  },
  mounted() {
    this.show = this.visible;
  },
  methods: {
    handleClose() {
      console.log("关闭");
      this.$emit("update:visible", false);
    },
  },
};
</script>

<template>
  <el-dialog
    title="试卷预览"
    :visible.sync="show"
    width="1000px"
    :before-close="handleClose"
  >
    <paper-body
      :paper-title="name"
      :paper-score="score"
      :question-list="questionList"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>
